import { Component, forwardRef, Input, OnInit } from '@angular/core'
import { ControlValueAccessor, NG_VALUE_ACCESSOR } from '@angular/forms'
import { DateRangePickerSelection } from '@tv3/shared/date-range-picker/date-range-picker.component'
import { EpochPipe } from '@tokeet/tv3-platform'
import { EpochUTCPipe } from '@tv3/pipes/utility/epoch-utc.pipe'

export const DATE_RANGE_SELECTOR_VALUE_ACCESSOR: any = {
  provide: NG_VALUE_ACCESSOR,
  useExisting: forwardRef(() => DateRangeControlComponent),
  multi: true,
}

@Component({
  selector: 'app-date-range-control',
  providers: [DATE_RANGE_SELECTOR_VALUE_ACCESSOR],
  styleUrls: ['./date-range-control.component.scss'],
  templateUrl: './date-range-control.component.html',
})
export class DateRangeControlComponent implements OnInit, ControlValueAccessor {
  @Input() placeholder
  @Input() local = true
  @Input() format = 'DD/MM/YYYY'
  value: DateRangePickerSelection
  onChange: any

  ngOnInit() {}

  getLabel(value, format, local = true) {
    if (!value) {
      return ''
    }
    const pipe = local ? new EpochPipe() : new EpochUTCPipe()
    return `${pipe.transform(value.from, format)} - ${pipe.transform(value.to, format)}`
  }

  writeValue(val: any): void {
    this.value = val
  }

  registerOnChange(fn: any): void {
    this.onChange = fn
  }

  registerOnTouched(fn: any): void {}

  onChangeFilterDateRange(val: DateRangePickerSelection) {
    this.value = val
    this.onChange(val)
  }
}
